import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  USER_TYPE_KEY,
  USER_PLAN_KEY,
  MONETIZATION_KEY,
} from "utils/constants";

import { parseErrorMessage } from "utils";
import { getProfile } from "features/Account/service";
import { getStocks } from "features/Market/service";
import { setItemInStorage } from "utils/storage";
import { getUserFlags, putUserFlags } from "services/index";

export const fetchUserDetails = createAsyncThunk(
  "layout/user",
  async (params, thunkAPI) => {
    try {
      const response = await getProfile();
      if (response?.stripe_subscription) {
        setItemInStorage(USER_PLAN_KEY, response?.surmount_plan?.id);
      } else {
        setItemInStorage(USER_PLAN_KEY, "");
      }
      setItemInStorage(USER_TYPE_KEY, response?.user_type);
      setItemInStorage(MONETIZATION_KEY, response?.dummy_premium);
      return response;
    } catch (error) {
      const msg = parseErrorMessage(error);
      return thunkAPI.rejectWithValue({ error: msg });
    }
  }
);

export const fetchStocks = createAsyncThunk(
  "layout/stocks",
  async (params, thunkAPI) => {
    try {
      const response = await getStocks();
      return response;
    } catch (error) {
      const msg = parseErrorMessage(error);
      return thunkAPI.rejectWithValue({ error: msg });
    }
  }
);

export const fetchUserFlags = createAsyncThunk(
  "layout/user/flags",
  async (params, thunkAPI) => {
    try {
      const response = await getUserFlags();
      return response;
    } catch (error) {
      const msg = parseErrorMessage(error);
      return thunkAPI.rejectWithValue({ error: msg });
    }
  }
);

export const updateUserFlags = createAsyncThunk(
  "layout/user/update-flags",
  async (flagName, thunkAPI) => {
    try {
      const userFlags = thunkAPI.getState().layout.userFlags;
      const payload = [...userFlags, { flag: flagName, is_active: true }];
      const response = await putUserFlags(payload);
      return response;
    } catch (error) {
      const msg = parseErrorMessage(error);
      return thunkAPI.rejectWithValue({ error: msg });
    }
  }
);
